module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "m-boxNotification m-boxNotification--page-level",
    class: [_vm.notificationState ? _vm.notificationState : ''],
    attrs: {
      "role": "alert"
    }
  }, [_c('span', [_vm._t("message")], 2), _vm._v(" "), (!_vm.hideCloseButton) ? _c('span', {
    staticClass: "m-boxNotification__close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fas fa-times"
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c87c712","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/molecules/BoxNotification.vue
// module id = 541
// module chunks = 2